/**
 * RetirementAgeSlider Component
 *
 * Reusable slider for selecting retirement age.
 * Used on both the dashboard card and /retirement page.
 */

interface RetirementAgeSliderProps {
  retirementAge: number;
  onRetirementAgeChange: (age: number) => void;
  minAge?: number;
  maxAge?: number;
  label?: string;
}

export default function RetirementAgeSlider({
  retirementAge,
  onRetirementAgeChange,
  minAge = 50,
  maxAge = 90,
  label = 'Target Retirement Age',
}: RetirementAgeSliderProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label
          htmlFor="retirement-age-slider"
          className="text-sm font-medium text-gray-700"
        >
          {label}
        </label>
        <span className="text-2xl font-bold text-gray-900">{retirementAge}</span>
      </div>
      <input
        id="retirement-age-slider"
        type="range"
        min={minAge}
        max={maxAge}
        value={retirementAge}
        onChange={(e) => onRetirementAgeChange(parseInt(e.target.value, 10))}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary-600"
      />
      <div className="flex justify-between text-xs text-gray-400 mt-1">
        <span>{minAge}</span>
        <span>{maxAge}</span>
      </div>
    </div>
  );
}
